<template>
  <mf-tooltip :disabled="disabled" max-width="250" top>
    <template #activator="{ on }">
      <mf-button v-if="!copied" type="icon" icon="content_copy" color="cinza-d20" :size="size" :disabled="disabled" @click="copy" />
      <mf-button v-if="copied" type="icon" fill icon="check_circle" color="verde-l10" :size="size" />
    </template>
    {{ copied ? 'Copiado!' : tooltip }}
  </mf-tooltip>
</template>

<script>
export default {
  name: 'CopyButton',
  props: {
    tooltip: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'sm',
    },
  },
  data: () => ({
    copied: false,
  }),
  methods: {
    copy() {
      this.$emit('click')
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 2000)
    },
  },
}
</script>
